import Head from "next/head";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

export function Favicons() {
  if(process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein-1") {
    return (
    <Head>
      <link rel="shortcut icon" type="image/x-icon" href="data:image/png;base64,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" />
    </Head>
    )
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1") {
    return (
      <Head>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-1/reflection-1-180x180.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-1/reflection-1-32x32.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-1/reflection-1-16x16.png`}
        />
        <link
          rel="shortcut icon"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-1/reflection-1-32x32.png`}
        />
      </Head>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2") {
    return (
      <Head>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-2/reflection-2-180x180.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-2/reflection-2-32x32.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-2/reflection-2-16x16.png`}
        />
        <link
          rel="shortcut icon"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-2/reflection-2-32x32.png`}
        />
      </Head>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3") {
    return (
      <Head>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-3/reflection-3-180x180.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-3/reflection-3-32x32.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-3/reflection-3-16x16.png`}
        />
        <link
          rel="shortcut icon"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-3/reflection-3-32x32.png`}
        />
      </Head>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4") {
    return (
      <Head>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-4/reflection-4-180x180.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-4/reflection-4-32x32.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-4/reflection-4-16x16.png`}
        />
        <link
          rel="shortcut icon"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-4/reflection-4-32x32.png`}
        />
      </Head>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "landing-1") {
    return (
      <Head>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-1/landing-1-180x180.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-1/landing-1-32x32.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-1/landing-1-16x16.png`}
        />
        <link rel="shortcut icon" href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-1/landing-1-32x32.png`} />
      </Head>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "landing-2") {
    return (
      <Head>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-2/landing-1-180x180.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-2/landing-1-32x32.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-2/landing-1-16x16.png`}
        />
        <link rel="shortcut icon" href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-2/landing-1-32x32.png`} />
      </Head>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "landing-3") {
    return (
      <Head>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-3/landing-1-180x180.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-3/landing-1-32x32.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-3/landing-1-16x16.png`}
        />
        <link rel="shortcut icon" href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-3/landing-1-32x32.png`} />
        <link rel="icon" href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-3/favicon.ico`} sizes="any" />
      </Head>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "landing-4") {
    return (
      <Head>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-4/landing-1-180x180.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-4/landing-1-32x32.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-4/landing-1-16x16.png`}
        />
        <link rel="shortcut icon" href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-4/landing-1-32x32.png`} />
        <link rel="icon" href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-4/favicon.ico`} sizes="any" />
      </Head>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "landing-5") {
      return (
        <Head>
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-5/favicon-180x180.png`}
          />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-5/favicon-32x32.png`}
          />
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-5/favicon-16x16.png`}
          />
          <link rel="shortcut icon" href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-5/favicon-32x32.png`} />
          <link rel="icon" href={`${publicRuntimeConfig.basePath}/icons/V2/V2-landing-5/favicon.ico`} sizes="any" />
        </Head>
      );
  }
  return (
    <Head>
      <link rel="icon" href={`${publicRuntimeConfig.basePath}/favicon.ico`} sizes="any" />
    </Head>
  );
}
